import { getIn } from 'immutable'

/**
 * @typedef ModalData
 * @type {Object}
 * @property {?string} url
 * @property {?string} title
 * @property {?string} message
 * @property {?string} itemId
 * @property {?boolean} share
 *
 * @typedef Modal
 * @type {Object}
 * @property {string} id - The unique identifier for the modal.
 * @property {ModalData} data - The data associated with the modal.
 *
 * @return {Immutable.Map<string,any> | null}
 */
export function selectModalsQueueHead(state) {
  return getIn(state, ['modals', 'queue', 0], null)
}
